// prefix of the useGetConsultations key for upcoming consultations, so invalidating it refreshes every page
export const UPCOMING_CONSULTATIONS_QUERY_KEY = ['consultations', 'upcoming'];
